import dayjs, { Dayjs } from "dayjs";

type GetToleranceTimeParams = {
  currentData?: string | Date | Dayjs;
  toleranceTime?: string;
  expiredText?: string;
  format?: string;
  onExpired?: () => void;
};
export function getToleranceTime({ currentData, toleranceTime = "00:00", expiredText = "Esgotado", format = "HH:mm:ss", onExpired }: GetToleranceTimeParams) {
  if (!currentData) return { time: expiredText, isExhausted: true };

  const now = dayjs();
  const time = dayjs(currentData);

  if (!time.isValid()) return { time: expiredText, isExhausted: true };

  const [hours, minutes] = toleranceTime.split(":").map(Number);

  const timeDiff = time.add(hours, "hour").add(minutes, "minute");
  const diffMs = timeDiff.diff(now);
  const isExhausted = diffMs <= 0;

  if (isExhausted) {
    onExpired?.();
  }

  // Use UTC to format the duration as absolute time (avoids timezone offsets like -3h)
  const timeLeft = dayjs.utc(Math.max(0, diffMs)).format(format);

  return {
    time: isExhausted ? expiredText : timeLeft,
    isExhausted
  };
}
